import { atom } from 'jotai/index';

import { IOwner } from '../../types';

export type SafeState = {
  _id: string;
  loading: boolean;
  address: string;
  owners: IOwner[];
  threshold: number;
  page: number;
  name: string;
};

const initial: SafeState = {
  loading: false,
  _id: '',
  address: '',
  owners: [],
  threshold: 0,
  page: 1,
  name: '',
};

// TODO_R: [FAR]
export const safeAtom = atom<SafeState>(initial);
